import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Icon from "@/v2-ui/icon"

export type UptimeEditPublicPreviewProps = ComponentProps<"div"> & {
  displayName: string
  description: string
  providerName: string
  isHidden: boolean
}

// UptimeEditPublicPreview shows what status.placepoint.no will
// render for this probe given the current form state. It mirrors
// the visual hierarchy the public-status `StatusCategoryServiceItem`
// uses (name -> provider -> description) without sharing code with
// it -- the public component lives in v2-status-client and pulling
// it across project boundaries would be more drag than the value
// the operator gets from a faithful preview.
function UptimeEditPublicPreview(props: UptimeEditPublicPreviewProps) {
  const {
    displayName,
    description,
    providerName,
    isHidden,
    className,
    ...divProps
  } = props

  return (
    <div
      className={cn(
        "uptime-edit-public-preview",
        isHidden && "uptime-edit-public-preview-is-hidden",
        className,
      )}
      {...divProps}
    >
      <div className="uptime-edit-public-preview-header">
        <span className="uptime-edit-public-preview-title">{displayName}</span>
        {isHidden && (
          <span className="uptime-edit-public-preview-hidden-badge">
            <Icon src="eye-crossed" size={11} />
            Hidden from public
          </span>
        )}
      </div>
      <div className="uptime-edit-public-preview-meta">
        Provided by {providerName}
      </div>
      {description ? (
        <p className="uptime-edit-public-preview-description">{description}</p>
      ) : (
        <p className="uptime-edit-public-preview-description uptime-edit-public-preview-description-empty">
          No description set. Customers will see the service name only.
        </p>
      )}
    </div>
  )
}

export default UptimeEditPublicPreview
